import ConfirmationModal from "../../../../ui/Modal/ConfirmationModal";
import Modal from "../../../../ui/Modal/Modal";

function DeleteTeamMemberModal({
  isOpen,
  onClose,
  onSubmit,
  loading,
}: {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void | Promise<void>;
  loading?: boolean;
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Are you sure you delete this user from the team?"
      subtitle="They will lose all access to the team unless they are reinvited."
    >
      <ConfirmationModal
        onClose={onClose}
        onSubmit={async () => {
          await onSubmit();
          onClose();
        }}
        loading={loading}
        destructive
        confirmationText="Delete user"
      />
    </Modal>
  );
}

export default DeleteTeamMemberModal;
